<template>
  <div class="general-update-msg">
    <div class="md:ut-flex md:ut-content-start">
      <div class="message"><strong>{{ name }}</strong> {{ message }}</div>
      <div class="date">{{ date }}</div>
    </div>
    <hr/>
  </div>
</template>

<script>
export default {
  name: 'GeneralUpdateMessage',
  props: {
    name: {
      required: false,
      type: String,
    },
    message: {
      required: true,
      type: String,
    },
    date: {
      required: false,
      type: String,
    },
  },
};

</script>

<style lang="scss" scoped>
    .general-update-msg {
      @apply ut-w-full ut-relative;
      @apply ut-p-6 ut-pb-0;
      color: #545352;

      .message {
        font-size: 14px;
        line-height: 22px;
        @apply ut-mb-2 ut-ml-0  ut-relative;
        padding-left: 42px;

        @screen md {
          @apply ut-mb-0;
          width: 488px;
        }

        &:before {
          content: url("../assets/styles/frontend-library/images/message.svg");
          @apply ut-absolute ut-left-0;
        }

      }

      &:last-child {
        @apply ut-pb-6;

        hr {
          display: none;
        }

      }

      hr {
        @apply ut-w-full ut-mt-6;
        border-top: 1px solid #E6E5E3;
      }

      .date {
        @apply ut-mt-0 ut-mr-0;
        font-size: 12px;
        line-height: 16px;
        padding-left: 42px;

        @screen md {
          @apply ut-pl-0;
        }

      }
    }
</style>
